// extracted by mini-css-extract-plugin
export default {"emoji-inline":"emoji-inline__2gYzj","emoji-fallback":"emoji-fallback__2OpKt"};